// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
   display: flex;
   flex-direction: column;
   width: 100%;
   height: 100%;
}

.header {
   height: 60px;
   padding: 8px 8px 8px 16px;
   background: #00a5e4;
   box-sizing: border-box;
   font-size: 1.2em;
   line-height: 44px;
   color: white;
}

app-loader {
   display: flex;
   opacity: 1;
}

app-webviewer {
   flex: 1;
   margin: 8px;
   box-shadow: 1px 1px 10px #999;
}

.viewer { width: 100%; height: 100%; }
`, "",{"version":3,"sources":["webpack://./src/app/dms/annotation-controller/annotation-controller.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,WAAW;GACX,YAAY;AACf;;AAEA;GACG,YAAY;GACZ,yBAAyB;GACzB,mBAAmB;GACnB,sBAAsB;GACtB,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;AACf;;AAEA;GACG,aAAa;GACb,UAAU;AACb;;AAEA;GACG,OAAO;GACP,WAAW;GAEX,6BAA6B;AAChC;;AAEA,UAAU,WAAW,EAAE,YAAY,EAAE","sourcesContent":[".page {\n   display: flex;\n   flex-direction: column;\n   width: 100%;\n   height: 100%;\n}\n\n.header {\n   height: 60px;\n   padding: 8px 8px 8px 16px;\n   background: #00a5e4;\n   box-sizing: border-box;\n   font-size: 1.2em;\n   line-height: 44px;\n   color: white;\n}\n\napp-loader {\n   display: flex;\n   opacity: 1;\n}\n\napp-webviewer {\n   flex: 1;\n   margin: 8px;\n   -webkit-box-shadow: 1px 1px 10px #999;\n   box-shadow: 1px 1px 10px #999;\n}\n\n.viewer { width: 100%; height: 100%; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
